<template>
	<div>
		<div class="box" v-if="community.customSettings">
			<fieldset>
				<legend>Details</legend>
				<md-field class="create-community">
					<label>Community:</label>
					<md-input v-model="community.name" name="community name" v-validate="'required'" @input="sanitizeName"></md-input>
				</md-field>
					<p class="error" v-show="errors.has('community name')">{{errors.first('community name')}}</p>
				<md-field class="create-community">
					<label>Code:</label>
					<md-input v-model="community.code" name="community code" v-validate="'required'" @input="sanitizeCode"></md-input>
				</md-field>
					<p class="error" v-show="errors.has('community code')">{{errors.first('community code')}}</p>
				<md-field>
					<label>Logo URL:</label>
					<md-input v-model="community.customSettings.logoURL" @input="sanitizeLogoUrl"></md-input>
				</md-field>
				<md-field>
					<label>Background Color:</label>
					<md-input v-model="community.customSettings.primaryColor" @input="sanitizeColor"></md-input>
				</md-field>
				<md-field>
					<label>Text Color:</label>
					<md-input v-model="community.customSettings.secondaryColor" @input="sanitizeColor"></md-input>
				</md-field>
				<md-button class="md-raised md-round md-accent" @click="save">{{ saveText }}</md-button>
			</fieldset>
		</div>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import { sanitizeInput, sanitizeUrl } from "../utils/sanitizer";
export default {
  data() {
    return {
      api: new API(),
      saveText: "Save",
      community: {
        name: "",
        code: "",
        customSettings: { primaryColor: "", secondaryColor: "", logoURL: "" }
      }
    };
  },
  watch: {
    $route: "loadData"
  },
  methods: {
	  sanitizeName(value) {
		  this.community.name = sanitizeInput(value);
	  },
	  sanitizeCode(value) {
		  this.community.code = sanitizeInput(value);
	  },
	  sanitizeLogoUrl(value) {
		  this.community.customSettings.logoURL = sanitizeUrl(value);
	  },
	  sanitizeColor(value) {
		  // Only allow valid hex colors or named colors
		  const sanitized = sanitizeInput(value);
		  const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$|^[a-zA-Z]+$/;
		  if (colorRegex.test(sanitized)) {
			  // Update the correct color property based on which input triggered the event
			  if (this.community.customSettings.primaryColor === value) {
				  this.community.customSettings.primaryColor = sanitized;
			  } else if (this.community.customSettings.secondaryColor === value) {
				  this.community.customSettings.secondaryColor = sanitized;
			  }
			  return sanitized;
		  }
		  // Clear the invalid value from the model
		  if (this.community.customSettings.primaryColor === value) {
			  this.community.customSettings.primaryColor = '';
		  } else if (this.community.customSettings.secondaryColor === value) {
			  this.community.customSettings.secondaryColor = '';
		  }
		  return '';
	  },
	  save: async function() {
    	this.$validator.validateAll().then(async result => {
    		if (result) {
		      // Sanitize all fields one final time before saving
		      const sanitizedCommunity = {
		        name: sanitizeInput(this.community.name),
		        code: sanitizeInput(this.community.code),
		        customSettings: {
		          logoURL: sanitizeUrl(this.community.customSettings.logoURL),
		          primaryColor: sanitizeInput(this.community.customSettings.primaryColor),
		          secondaryColor: sanitizeInput(this.community.customSettings.secondaryColor)
		        }
		      };

		      await this.api.post(`communities/`, sanitizedCommunity).then(community => {
		        this.saveText = "Saved";
		        this.$emit("reload");
		        this.$router.push(`/communities/${community.data._id}`);
		      });
			}
		});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CreateCommunity.vue